import { render, staticRenderFns } from "./ScreeningDetailsChild.vue?vue&type=template&id=436922ef"
import script from "./ScreeningDetailsChild.vue?vue&type=script&lang=js"
export * from "./ScreeningDetailsChild.vue?vue&type=script&lang=js"
import style0 from "./ScreeningDetailsChild.vue?vue&type=style&index=0&id=436922ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports